module.exports = __webpack_public_path__ + "static/media/newQuiz.cf012064.svg";